import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { FurnishingState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors(
    (state: RootState): FurnishingState => state.furnishing,
);

export default selectors;
